import React, { Fragment } from "react";

import "./NoContent.css";
import Button from "../../components/Button/Button";

const NoContent = (props) => (
  <Fragment>
    <div
      className={[
        "mn-info-box mn-info-box--empty",
        props.empty ? "mn-info-box--noempty" : "mn-info-box--empty",
      ].join(" ")}
    >
      {props.image && <img className="mn-info-img" src={props.image} alt="Empty" />}
      <p className="mn-info-statement mn-info-statement--bg">
        {props.firstInfoStatement}
      </p>
      <p className="mn-info-statement">{props.secondInfoStatement}</p>
      {props.button!=="" && (
        <Button
          design="greenish"
          mode={""}
          type="submit"
          onClick={props.onClickHandler}
        >
          {props.button}
        </Button>
      )}
    </div>
  </Fragment>
);

export default NoContent;
